import { useEffect, useState } from "react"
import { Form, FormGroup, Label, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Col, Row,Card} from "reactstrap"
import { useForm } from "react-hook-form"
import ApiService from "../../services/apiService"
import CommonCardHeader from "../../coreComponents/CommonCardHeader"
import { toast } from "react-toastify"

const AddOms = () => {
    const [chackData, setChackData] = useState<any>([])
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedChack, setSelectedChack] = useState<any>(null);
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const toggleDropdown = () => {setDropdownOpen(prev => !prev)
    }

    useEffect(() => {

        const getChack = async () => {
            try {
                const response = await ApiService.axiosApi(`/chack`, {
                    method: 'GET'
                });
                if (response.success) {
                    setChackData(response.data)
                } else {
                    console.log(response.message || response.status || "unable to load chack data")
                }

            } catch (error) {
                console.log(error)
            }
        }
        getChack();
    }, [])


    useEffect(()=>{
          
            if(selectedChack!=null){
                 setValue("ChackName",selectedChack.chackName)
                 setValue("OnOfValve" ,selectedChack.no_Of_ON_OF_Valves)
                 setValue("DistributaryZone", selectedChack.distributary_Zone)
                 setValue("SchemeVillage", selectedChack.scheme_Village)
                 setValue("Duty",selectedChack.duty)
                 setValue("UpdateTime",selectedChack.dateTime)
            }

          
    },[chackData])

    const onSubmit = async (data:any)=>{
         
        try{
             const response = await ApiService.axiosApi(`/oms/addoms`,{
                 method:'POST',
                 data: data
             })
             if(response.success){
                 toast.success('OMS Added Successfully')
             }else{
                console.log(response.message||response.status||"unable to post oms")
             }
            
        }catch(error){
            console.log(error)
        }
    }


    return (
        <>

            <div style = {{width :'100%' , height : "100"}}>
               <Card className="p-5 pt-1" >
               <CommonCardHeader title="Update User" headClass="pb-3" />
                <Form onSubmit={handleSubmit( onSubmit)}>

                    <FormGroup>
                        <Label className="col-form-label">Chack</Label>
                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                            <DropdownToggle
                                color="primary"
                                className="custom-dropdown-toggle d-flex align-items-center justify-content-between"
                                style={{
                                    backgroundColor: '#007bff',
                                    borderColor: '#007bff',
                                    color: '#fff',
                                    fontWeight: 500,
                                    borderRadius: '6px',
                                    padding: '8px 16px',
                                    width: '200px',
                                }}>
                                {selectedChack?.chackName || "Select Role"}
                            </DropdownToggle>
                            <DropdownMenu
                                className="custom-dropdown-menu"
                                style={{
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.1)',
                                    borderRadius: '8px',
                                    padding: '8px 0',

                                }}>
                                {chackData.map((data: any) => {
                                    return (
                                        <DropdownItem key={data.id} onClick={() => setSelectedChack(data)}>
                                            {data.chackName}
                                        </DropdownItem>
                                    );
                                })}


                            </DropdownMenu>
                        </Dropdown>
                    </FormGroup>

                    <FormGroup>
                        <Row>
                            <Col md={6}>
                                <input
                                    className="form-control"
                                    type="text"
                                    {...register("ChackName", {
                                        required: "ChackName is required",
                                       
                                    })}
                                />
                            </Col>

                            <Col md={6}>
                            <input
                                    className="form-control"
                                    type="text"
                                    {...register("OnOfValve", {
                                        required: "Valves is required",
                                       
                                    })}
                                />
                            </Col>
                        </Row>
                    </FormGroup>


                    <FormGroup>
                        <Row>
                            <Col md={6}>
                                <input
                                    className="form-control"
                                    type="text"
                                    {...register("DistributaryZone", {
                                        required: "DistrubutaryZone is required",
                                       
                                    })}
                                />
                            </Col>

                            <Col md={6}>
                            <input
                                    className="form-control"
                                    type="text"
                                    {...register("schemeVillage", {
                                        required: "Scheme Village is required",
                                       
                                    })}
                                />
                            </Col>
                        </Row>
                    </FormGroup>

                    <FormGroup>
                        <Row>
                            <Col md={6}>
                                <input
                                    className="form-control"
                                    type="text"
                                    {...register("Duty", {
                                        required: "DistrubutaryZone is required",
                                       
                                    })}
                                />
                            </Col>

                            <Col md={6}>
                            <input
                                    className="form-control"
                                    type="text"
                                    {...register("UpdateTime", {
                                        required: "Scheme Village is required",
                                       
                                    })}
                                />
                            </Col>
                        </Row>
                    </FormGroup>

                    <FormGroup>
                        <Row>
                            <Col md={6}>
                                <input
                                    className="form-control"
                                    type="text"
                                    {...register("Pressure", {
                                        required: "Pressure is required",
                                       
                                    })}
                                />
                            </Col>

                            <Col md={6}>
                            <input
                                    className="form-control"
                                    type="text"
                                    {...register("FlowRate", {
                                        required: "Flow Rate is required",
                                       
                                    })}
                                />
                            </Col>
                        </Row>
                    </FormGroup>

                    <FormGroup>
                        <Row>
                            <Col md={6}>
                                <input
                                    className="form-control"
                                    type="text"
                                    {...register("TodayVolume", {
                                        required: "TodayVolume is required",
                                       
                                    })}
                                />
                            </Col>

                            <Col md={6}>
                            <input
                                    className="form-control"
                                    type="text"
                                    {...register("OnValves", {
                                        required: "Today is required",
                                       
                                    })}
                                />
                            </Col>
                        </Row>
                    </FormGroup>

                    <FormGroup>
                        <Row>
                            <Col md={6}>
                                <input
                                    className="form-control"
                                    type="text"
                                    {...register("Door1", {
                                        required: "Door1 is required",
                                       
                                    })}
                                />
                            </Col>

                            <Col md={6}>
                            <input
                                    className="form-control"
                                    type="text"
                                    {...register("Door2", {
                                        required: "Door2 is required",
                                       
                                    })}
                                />
                            </Col>
                        </Row>
                    </FormGroup>

                    <FormGroup>
                        <Row>
                            <Col md={6}>
                                <input
                                    className="form-control"
                                    type="text"
                                    {...register("Networkstatus", {
                                        required: "NetworkStatus is required",
                                       
                                    })}
                                />
                            </Col>

                            <Col md={6}>
                            <input
                                    className="form-control"
                                    type="text"
                                    {...register("Battery", {
                                        required: "Battery is required",
                                       
                                    })}
                                />
                            </Col>
                        </Row>
                    </FormGroup>

                    <FormGroup>
                        <Row>
                            <Col md={6}>
                                <input
                                    className="form-control"
                                    type="text"
                                    {...register("SolarVoltage", {
                                        required: "SolarVoltage is required",
                                       
                                    })}
                                />
                            </Col>

                            <Col md={6}>
                            <input
                                    className="form-control"
                                    type="text"
                                    {...register("Temprature", {
                                        required: "Temprature is required",
                                       
                                    })}
                                />
                            </Col>
                        </Row>
                    </FormGroup>

                    <FormGroup>
                        <Row>
                            <Col md={6}>
                                <input
                                    className="form-control"
                                    type="text"
                                    {...register("WaterMeter", {
                                        required: "Water Meter is required",
                                       
                                    })}
                                />
                            </Col>

                            <Col md={6}>
                            <input
                                    className="form-control"
                                    type="text"
                                    {...register("RomsAuto", {
                                        required: "RomsAuto is required",
                                       
                                    })}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </Form>
                </Card>
            </div>
        </>


    )
}

export default AddOms





